import React, { Component } from "react";
import { Descriptions, Dropdown, Select, Menu, Button } from "antd";
import { strings, generateLocationString } from "../../../helpers";
const { Option } = Select;

export default class ClinicBasicInfoView extends Component {
  render() {
    const { details, handleEditLocation } = this.props;
    return (
      <Descriptions layout="vertical" bordered>
        <Descriptions.Item label="Name">
          {(details && details.name) || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Address" span={3} className="rel-pos">
          <div className="address-field">
            {details?.location
              ? generateLocationString(details?.location)
              : "--"}
          </div>
          <Button type="primary" onClick={() => handleEditLocation(true)} className="edit-link">Edit</Button>
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          {(details && details.email) || "--"}
        </Descriptions.Item>
        {details &&
          details.clinic_website &&
          details.clinic_website &&
          details.clinic_website.clinic_domains.length > 0 &&
          details.clinic_website.clinic_domains.map((obj, index) => {
            return (
              <Descriptions.Item label={`Website ${index + 1}`}>
                {obj.domain_name || "--"}
              </Descriptions.Item>
            );
          })}

        {details &&
          details.location &&
          details.location.phone_numbers.length > 0 &&
          details.location.phone_numbers.map((obj, index) => (
            <Descriptions.Item label={`Phone Number ${index + 1}`}>
              {(obj.phone_number &&
                `${obj.phone_number} (${obj.phone_type})`) ||
                "--"}
            </Descriptions.Item>
          ))}
        <Descriptions.Item label={"Phone"}>
          {(details && details.phone_number) || "--"}
        </Descriptions.Item>
      </Descriptions>
    );
  }
}
